import type React from "react"
import { useEffect, useRef } from "react"
import { Card } from "react-bootstrap"
import * as echarts from "echarts"

// @ts-ignore
const EnvironmentWiseChart: React.FC = ({ MultiBarChartData }) => {
    const chartRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const colors = ["#00B386", "#F2C94C", "#F2994A", "#EB5757"]

        const option = {
            title: {
                text: MultiBarChartData?.title,
                textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    color: "#18181B",
                    lineHeight: 16
                },
                left: "left",
                top: 10,
                subtext: MultiBarChartData?.subtitle,
                subtextStyle: {
                    fontSize: 14,
                    color: "#838FB4",
                    fontWeight: 400,
                    lineHeight: 16,
                    width: 700,
                    overflow: "break"
                }
            },
            // tooltip: {
            //     trigger: "axis",
            //     axisPointer: { type: "shadow" }
            // },
            tooltip: {
                trigger: "axis",
                axisPointer: { type: "shadow" },
                formatter: function (params: any) {
                    const envIndex = params[0].dataIndex;
                    const env = MultiBarChartData.xAxis.env[envIndex];

                    let tooltipHtml = `<strong>${env}</strong><br/>`;

                    params.forEach((p: any) => {
                        const series = MultiBarChartData && MultiBarChartData?.series?.find((s: any) => s.name === p.seriesName);

                        // tooltipHtml += `<br/><span style="font-weight:600">${p.seriesName}</span>: ${p.value}`;
                        tooltipHtml += `<br/>${p.marker}<strong>${p.seriesName}</strong>: ${p.value}`;
                        
                        const breakdown = series?.breakdown?.[env];

                        if (breakdown && Object.keys(breakdown).length > 0) {
                            tooltipHtml += `<br/>`;
                            Object.entries(breakdown).forEach(([code, count]) => {
                                tooltipHtml += `&nbsp;&nbsp;• ${code}: ${count}<br/>`;
                            });
                        }
                    });

                    return tooltipHtml;
                }
            },

            legend: {
                data: MultiBarChartData && MultiBarChartData?.series?.map((item: any) => item.name),
                bottom: 10,
                icon: "circle",
                itemGap: 16,
                // textStyle: {
                //     fontSize: 12
                // }
            },
            grid: {
                top: "25%",
                bottom: "25%",
            },
            xAxis: {
                type: "category",
                data: MultiBarChartData?.xAxis?.env,
                name: MultiBarChartData?.xAxis?.name,
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 14,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 11,
                    color: "#4B4B53",
                    fontWeight: 400,
                    rotate: 45,
                    formatter: function (value: string) {
                        const maxLength = 10;
                        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                    }
                },
                // axisTick: { show: false }
            },
            yAxis: {
                type: "value",
                name: MultiBarChartData?.yAxis?.name,
                nameLocation: "middle",
                nameRotate: 90,
                // nameGap: 45,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 14,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "rgba(0, 102, 204, 0.25)"
                    }
                }
            },
            series: MultiBarChartData?.series?.map((s: any, index: number) => ({
                name: s?.name,
                type: "bar",
                data: s?.data,
                barWidth: 28,
                itemStyle: {
                    color: colors[index]
                }
            }))
        }

        chart.setOption(option)

        window.addEventListener("resize", () => chart.resize())
        return () => chart.dispose()
    }, [MultiBarChartData])

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
                <div ref={chartRef} style={{ width: "100%", height: "400px" }} />
            </Card.Body>
        </Card>
    )
}

export default EnvironmentWiseChart
